import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAda = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m32 22.716-2.053-2.082v-3.118H28.58v1.734l-2.053-2.08-5.47 5.546v.347h1.37v3.466h3.417v-2.082h1.368v2.082h3.418v-3.466H32zm-11.253-6.731-3.891-3.942V6.13h-2.594v3.284L10.37 5.47 0 15.985v.659h2.592v9.885h6.484v-3.942h2.594v3.942h6.48v-9.885h2.597z" /></svg>;
export default SvgAda;